import * as THREE from 'three';

import { COLORS } from '../game/constants';

/**
 * Dark-navy arcade lighting.
 *
 * A low ambient wash keeps the board readable, a single directional key gives
 * the geometry its shape, and two coloured point lights supply the cyan/magenta
 * neon rim that defines the arcade look.
 */
export function buildLighting(scene: THREE.Scene): void {
  scene.add(new THREE.AmbientLight(0x35578a, 1.1));

  scene.add(new THREE.HemisphereLight(0x9ad8ff, 0x0a1024, 0.7));

  // Angled well off-axis so wall sides catch light and the maze reads as relief
  // rather than as a flat disc.
  const key = new THREE.DirectionalLight(0xffffff, 2.6);
  key.position.set(3.4, 4.2, 3.4);
  scene.add(key);

  const rimCyan = new THREE.PointLight(COLORS.neonCyan, 26, 14, 2);
  rimCyan.position.set(-2.8, 1.6, 2.4);
  scene.add(rimCyan);

  const rimMagenta = new THREE.PointLight(COLORS.neonMagenta, 22, 14, 2);
  rimMagenta.position.set(2.8, -1.8, 2.1);
  scene.add(rimMagenta);

  const underGlow = new THREE.PointLight(COLORS.ringBlue, 12, 10, 2);
  underGlow.position.set(0, -2.6, 1.4);
  scene.add(underGlow);
}
